import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
// import Breadcrumb from "../components/Breadcrumb";
import Conversation from "../components/ConversationsLayer";

const ConversationPageLayer = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        {/* <Breadcrumb title="Conversations" /> */}

        {/* ConversationPageLayer */}
        <Conversation />

      </MasterLayout>

    </>
  );
};

export default ConversationPageLayer; 
